import {
    Component, Input,
} from '@angular/core';

@Component({
    selector: 'phone-help',
    templateUrl: './phone-help.component.html',
    styleUrls: ['./phone-help.component.scss'],
})
export class PhoneHelpComponent {
    @Input()
    public onAdvisoryClick: () => void;

    @Input()
    public onCancelClick: () => void;
}
